import { t } from 'i18next';

export const addPlayerInputFields: {
  label: string;
  errorMsg: string[] | undefined;
  name: string;
  type: string;
  icon: string;
  className: string;
  onChange: () => void;
}[] = [
  {
    label: 'Name',
    errorMsg: undefined,
    name: 'name',
    type: 'text',
    icon: 'bi bi-person-fill',
    className: 'name',
    onChange: () => {},
  },
  {
    label: 'Email',
    errorMsg: undefined,
    name: 'email',
    type: 'text',
    icon: 'bi bi-envelope-fill',
    className: 'email',
    onChange: () => {},
  },
];

export const addPlayerSubmitButton = [
  {
    text: t('input_fields.button_submit'),
    className: 'btn btn-primary w-100',
    icon: '',
    onClick: (e: any) => {},
  },
];
